import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next'

import AssetManager from '../../common/components/AssetManager'
import Editor from '../Editor/Editor'

import Modal from '.'

const getPropertyValue = async path => {
    const state = await Editor.serializeProject()

    return eval(`state.${path}`)
}

const RankBattleOptions = ({ is_open, overlay_close, events, data, project, t, set_data }) => {
    const [assetmanager, setAssetmanagerState] = useState({ is_open: false, on_place_image: () => {} })

    const [componentData, setComponentData] = useState(null)

    useEffect(() => {
        const fetch = async () => {
            const { screenId, componentId } = data.control

            const value = await getPropertyValue(`router.screens.${screenId}.components.${componentId}`)

            if (value) {
                setComponentData(value)
            }
        }

        if (data && data.propertyString) {
            fetch()
        }
    }, [data])

    if (componentData === null) {
        return null
    }

    return (
        <>
            <Modal
                settings={{ overlay_close: overlay_close }}
                classes={{
                    overlay: '',
                    modal: 'rank-battle-style',
                    closeButton: '',
                    closeIcon: '',
                }}
                data={{ open: is_open, max_width: 960 }}
                events={{ onCloseModal: events.on_close, onExited: () => {} }}
            >
                <div className="head head-v1">{t('_components._modal._rank_battle_options.title')}</div>
                <div className="body">
                    <div className="title">{t('_components._modal._rank_battle_options.text_1')}</div>
                    <div className="description">{t('_components._modal._rank_battle_options.text_2')}</div>
                    <div className="items">
                        {componentData.cardIds.slice(0, componentData.numberOfCards).map(id => {
                            return (
                                <div
                                    key={id}
                                    className="item"
                                    onClick={() => {
                                        setAssetmanagerState({
                                            is_open: true,
                                            on_place_image: ({ src }) => {
                                                const updatedImageLinks = {
                                                    ...componentData.imageLinks,
                                                    [id]: src,
                                                }
                                                set_data(updatedImageLinks)

                                                const updatedComponentData = {
                                                    ...componentData,
                                                    imageLinks: updatedImageLinks,
                                                }
                                                setComponentData(updatedComponentData)
                                            },
                                        })
                                    }}
                                >
                                    <div
                                        className="img"
                                        style={{ backgroundImage: `url(${componentData.imageLinks[id]})` }}
                                    />
                                    <div className="photo_icon">
                                        <svg
                                            width="12"
                                            height="11"
                                            viewBox="0 0 12 11"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M11 1H8.38695C8.30181 0.433969 7.8134 0 7.22363 0H4.77657C4.1868 0 3.69839 0.433969 3.61324 1H1C0.447715 1 0 1.44772 0 2V10C0 10.5523 0.447715 11 1 11H11C11.5523 11 12 10.5523 12 10V2C12 1.44772 11.5523 1 11 1ZM6 9C7.65685 9 9 7.65685 9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9ZM5.99983 8C7.1044 8 7.99983 7.10457 7.99983 6C7.99983 4.89543 7.1044 4 5.99983 4C4.89526 4 3.99983 4.89543 3.99983 6C3.99983 7.10457 4.89526 8 5.99983 8Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </Modal>

            <AssetManager
                isOpen={assetmanager.is_open}
                projectId={project.projectId}
                onPlaceImage={assetmanager.on_place_image}
                onClose={() => setAssetmanagerState({ ...assetmanager, is_open: false })}
            />
        </>
    )
}

export default withTranslation('translations')(RankBattleOptions)
